import axios from 'axios';


// Create axios instance with default config
// export const apiClient = axios.create({
//   baseURL: 'http://localhost:4000/api/admin'
// });
// const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

console.log('API_BASE_URL:', API_BASE_URL);

export const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api/admin`
});

// Add token to all requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken') || 'dev-token';
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default apiClient;
